import { NgModule } from '@angular/core';

import { MarketplaceComponent }
  from '@kitch/user/pages/user-panel/marketplace-page/components/marketplace/marketplace.component';
import { MarketplaceRoutingModule } from '@kitch/user/pages/user-panel/marketplace-page/marketplace-routing.module';
import { UserSharedModule } from '@kitch/user/shared/user-shared.module';

@NgModule({
  declarations: [MarketplaceComponent],
  imports: [MarketplaceRoutingModule, UserSharedModule],
  providers: [],
})
export class MarketplaceModule { }
